import Header from "../../components/public/header";
import Navigation from "../../components/public/navigation";
import Main from "../../components/public/sections/main";
import Home from "../../components/public/home";
import Footer from "../../components/public/footer";

const HomePage = () => {
  return (
    <>
      <Navigation />
      <Header />
      <Main pageHeading={"मुखपृष्ठ"} content={<Home />} />
      <Footer />
    </>
  );
};

export default HomePage;
